import { useMemo } from "react";
import { ScreeningItem } from "../../types/Screening";
import { getFlagUrl } from "../../services/QuotationsServices";

type Props = {
    data: ScreeningItem;
};

export const ScreeningFlagBody = (props: Props) => {
    const { data } = props;

    const flagUrl = useMemo(() => getFlagUrl(data.flag_code ?? "unk"), [data]);

    return (
        <div className="flex align-items-center">
            <img
                className="screening-table-flag mr-2"
                alt={data.flag_code}
                src={flagUrl}
            />
            <p>{`${data.flag_state} (${data.flag_code})`}</p>
        </div>
    );
};
